import { useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { EMPTY_OBJECT, AppContext } from 'commons-ui';

import usePermission from 'routes/usePermission';

const useZookeeperActions = (makeActionHandler: any, makeActionList: any) => {
	const history = useHistory();
	const location = useLocation();
	const { app } = useContext(AppContext);
	const { hasPermission } = usePermission();
	const getActionHandler = (action: any, params = EMPTY_OBJECT) => {
		return makeActionHandler(action, { ...params, location, history, isGold: app.isGold });
	};
	const getActionList = (params = EMPTY_OBJECT) => {
		const actionList = makeActionList({
			...params,
			history,
			appName: app.appName,
			isGold: app.isGold,
			hasPermission
		});
		const { addAction = EMPTY_OBJECT } = actionList;

		const modifiedActionList = { ...actionList };
		if (!addAction.isEnabled?.()) {
			modifiedActionList.addAction = null;
		}
		return modifiedActionList;
	};
	return {
		getActionHandler,
		getActionList
	};
};

export default useZookeeperActions;
